import utils from '@/common/utils'
import config from '@/common/config'
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
    getUserInfo,
    getUserInfoWithAccountFallback,
    getChengyuan,
    getBumen
}

function getUserInfo() {
    return new Promise((resolve, reject) => {
        try {
            var userinfo = utils.getStorage('user')
            NetToWeb.getUserInfo().then(function (data) {
                userinfo = JSON.parse(data)
                if(userinfo && userinfo.yhid && userinfo.yhid == 1156182) {
                    userinfo.bmbm = "hjkf2"
                }
                utils.setStorage('fallback_ywy_user', userinfo)
                //utils.setStorage('user', userinfo)
                resolve(userinfo)
            }, function (error) {
                reject(error)
            })
            // var url = config.proApi + "api/data/login/main";
            // utils.ajax("GET", url, params, 5000).then(function(res) {
            //     resolve(res)
            // }, function(err) {
            //     reject(err)
            // });
        } catch (error) {
            reject(error)
        }
    });
}

function getYwyUserInfoByAccount(account) {
    return new Promise((resolve, reject) => {
        var baseUrl = config.vhApi || config.livingApi;
        if (baseUrl.charAt(baseUrl.length - 1) !== "/") {
            baseUrl += "/"
        }
        var url = baseUrl + "v1/api/ywy_user_info";
        utils.ajax("POST", url, { wx_account: account }, 5000).then(function (res) {
            if (res && res.code === 0 && res.data) {
                resolve(res.data)
            } else {
                reject(new Error((res && (res.msg || res.message)) || '未查询到业务员信息'))
            }
        }, function (err) {
            reject(err)
        });
    });
}

function normalizeUserInfo(userinfo) {
    if (!userinfo || !userinfo.yhid) {
        return null
    }
    if (userinfo.rsMainkeyID && !userinfo.rsMainKeyid) {
        userinfo.rsMainKeyid = userinfo.rsMainkeyID
    }
    return userinfo
}

function promptYwyAccount() {
    return ElMessageBox.prompt('当前页面未获取到业务员用户信息，请输入业务员账号后继续。', '业务员账号', {
        confirmButtonText: '查询',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入业务员账号',
        closeOnClickModal: false,
        inputValidator: (value) => {
            if (!value || !value.trim()) {
                return '请输入业务员账号'
            }
            return true
        }
    }).then(({ value }) => {
        return getYwyUserInfoByAccount(value.trim()).then((userinfo) => {
            userinfo = normalizeUserInfo(userinfo)
            if (!userinfo) {
                throw new Error('未查询到业务员信息')
            }
            if(userinfo && userinfo.yhid && userinfo.yhid == 1156182) {
                userinfo.bmbm = "hjkf2"
            }
            utils.setStorage('fallback_ywy_user', userinfo)
            ElMessage.success('业务员信息获取成功')
            return userinfo
        })
    }).catch((error) => {
        if (error !== 'cancel' && error !== 'close') {
            ElMessage.error(error && error.message ? error.message : '业务员信息获取失败')
        }
        return Promise.reject(error)
    })
}

function getUserInfoWithAccountFallback() {
    return getUserInfo().then((userinfo) => {
        userinfo = normalizeUserInfo(userinfo)
        if (userinfo) {
            return userinfo
        }
        return promptYwyAccount()
    }).catch(() => {
        try {
            var fallbackUser = normalizeUserInfo(utils.getStorage('fallback_ywy_user'))
            if (fallbackUser) {
                return fallbackUser
            }
        } catch (error) {
            utils.clearStorage('fallback_ywy_user')
        }
        return promptYwyAccount()
    })
}

function getChengyuan(rsOperateID, cxbmbm) {
    return new Promise((resolve, reject) => {
        // let yhlx = 1
        // if (cxbmbm.indexOf('hjkf') > -1) {
        //     yhlx = 3;
        // }
        var params = {
            rsOperateID: rsOperateID,
            cxbmbm: cxbmbm,
            yhlx: 0,
            CompanyID: 0
        };
        var url = "http://10.10.0.32:8012/api/oa/P_C_XT_getTZYHXX";
        utils.ajax("GET", url, params, 5000).then(function (res) {
            resolve(res)
        }, function (err) {
            reject(err)
        });
    });
}

function getBumen(rsOperateID) {
    return new Promise((resolve, reject) => {
        var params = {
            rsOperateID: rsOperateID,
            ywlx: 1,
            khlsj: 0,
            gnlx: "THJLFQXCX",
            qxdm: ""
        };
        var url = "http://10.10.0.32:8012/api/oa/P_C_XT_getQXBM";
        utils.ajax("GET", url, params, 5000).then(function (res) {
            resolve(res)
        }, function (err) {
            reject(err)
        });
    });
}
